import { createFileRoute } from '@tanstack/react-router';
import { AdminSessionsTable } from '@/components/AdminSessionsTable';

export const Route = createFileRoute('/admin')({
  component: AdminPage,
});

function AdminPage() {
  return <AdminSessionsTable />;
}